import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { CdsToast } from './components/cds-toast-message/services';
import { duplicateErrorHelper } from './duplicateErrorHelper';

const { isDuplicateError, setNewLastError } = duplicateErrorHelper();

const isNetworkError = (error: any) => {
  return error?.code === 'ERR_NETWORK';
};

const handleApiError = (error: any) => {
  if (error?.response?.status === 401) {
    window.location.reload();
  }

  if (
    error.message &&
    !error.skipToast &&
    !isNetworkError(error) &&
    !isDuplicateError(error)
  ) {
    setNewLastError(error);
    CdsToast.error(error.message, {
      ...(error.button_text && error.button_link
        ? {
            buttonText: error.button_text,
            buttonOnClick: () => window.open(error.button_link, '_blank'),
          }
        : {}),
    });
  }

  console.error('Something went wrong', error.message);
};

export const defaultQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => !error?.message && failureCount < 1,
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
  },
  queryCache: new QueryCache({ onError: handleApiError }),
  mutationCache: new MutationCache({ onError: handleApiError }),
});
